<template>
  <select class="form-select"
          aria-label="Default select example" :name="this.attributeName">
    <option v-for="option in this.options" :value="option.value" :selected="option.selected">{{ option.name }}</option>
  </select>
</template>

<script>

export default {
  name: "DurationDropdown",
  components: {},
  props: {
    old: Number,
    attributeName: String
  },
  data: function () {
    return {
      options: [],
      bigger_options: [
        {
          value: 1440,
          name: '1 day'
        },
        {
          value: 2880,
          name: '2 days'
        },
        {
          value: 4320,
          name: '3 day'
        },
        {
          value: 5760,
          name: '4 day'
        },
        {
          value: 7200,
          name: '5 day'
        },
        {
          value: 8640,
          name: '6 day'
        },
        {
          value: 10080,
          name: '1 week'
        }
      ],
    }
  },
  created() {
    let value, name, hours, mins;

    for (let i = 1; i <= 96; i++) {

      value = 15 * i;

      if (i < 4) {
        name = value + ' min'
      } else {
        hours = Math.floor(i / 4);
        mins = (value - (Math.floor(i / 4) * 60))
        name = (i % 4 === 0) ? hours + ' h' : hours + ' h ' + mins + ' min';
      }

      this.options.push({
        value: value,
        name: name
      });
    }

    this.options = this.options.concat(this.bigger_options);

  },
  mounted() {
    if (this.old !== 0) {
      this.options.find(el => {
        return el.value == this.old
      }).selected = true;
    }

  }
}
</script>

<style scoped>

</style>
